export default __webpack_public_path__ + "static/media/timeline-04.3782d642.png";